import {
  GET_USER,
  GET_USERSLIST,
  CLEAR_USER,
  CLEAR_ADMIN,
  GET_BUILDING,
  CLEAR_BUILDING,
  GET_BUILDINGSLIST,
  GET_FLOORSLIST,
  GET_FLOOR,
  CLEAR_FLOOR,
  GET_CLIENTSLIST,
  GET_CLIENT,
  SET_CLIENT,
  CLEAR_CLIENT,
  GET_CONFIGS,
  CLEAR_CONFIGS,
  GET_DEPLOYMENTLIST,
  SET_BUILDING,
  SET_FLOOR,
  GET_ROOMSLIST,
  GET_ROOM,
  SET_ROOM,
  CLEAR_ROOM,
  GET_PROJECTLIST,
  GET_PROJECT,
  SET_PROJECT,
  CLEAR_PROJECT,
  GET_DEVICELIST,
  GET_DEVICE,
  SET_DEVICE,
  CLEAR_DEVICE,
  MODIFY_CONFIGS,
  GET_DEPLOYMENT,
} from "../actions/types";

const initialState = {
  usersList: [],
  user: null,
  userListLoading: true,
  userLoading: true,
  clientsList: [],
  client: null,
  clientListLoading: true,
  clientLoading: true,
  buildingsList: [],
  building: null,
  buildingListLoading: true,
  buildingLoading: true,
  floorsList: [],
  floor: null,
  floorListLoading: true,
  floorLoading: true,
  configs: null,
  configsLoading: true,
  configModified: null,
  projectsList: [],
  project: null,
  projectListLoading: true,
  projectLoading: true,
  deploymentsList: [],
  deployment: null,
  deploymentListLoading: true,
  deploymentLoading: true,
  devicesList: [],
  device: null,
  deviceListLoading: true,
  deviceLoading: true,
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_USERSLIST:
      return { ...state, usersList: payload, userListLoading: false };
    case GET_USER:
      return { ...state, user: payload, userLoading: false };
    case CLEAR_USER:
      return { ...state, user: null, userLoading: true };
    case GET_CLIENTSLIST:
      return { ...state, clientsList: payload, clientListLoading: false };
    case GET_CLIENT:
      return { ...state, client: payload, clientLoading: false };
    case SET_CLIENT:
      return { ...state, client: payload, clientLoading: false };
    case CLEAR_CLIENT:
      return { ...state, client: null, clientLoading: true };
    case GET_BUILDINGSLIST:
      return { ...state, buildingsList: payload, buildingListLoading: false };
    case GET_BUILDING:
      return { ...state, building: payload, buildingLoading: false };
    case SET_BUILDING:
      return { ...state, building: payload, buildingLoading: false };
    case CLEAR_BUILDING:
      return { ...state, building: null, buildingLoading: true };
    case GET_FLOORSLIST:
      return { ...state, floorsList: payload, floorListLoading: false };
    case GET_FLOOR:
      return { ...state, floor: payload, floorLoading: false };
    case SET_FLOOR:
      return { ...state, floor: payload, floorLoading: false };
    case CLEAR_FLOOR:
      return { ...state, floor: null, floorLoading: true };
    case GET_ROOMSLIST:
      return { ...state, roomsList: payload, roomListLoading: false };
    case GET_ROOM:
      return { ...state, room: payload, roomLoading: false };
    case SET_ROOM:
      return { ...state, room: payload, roomLoading: false };
    case CLEAR_ROOM:
      return { ...state, room: null, roomLoading: true };
    case GET_CONFIGS:
      return { ...state, configs: payload, configsLoading: false };
    case MODIFY_CONFIGS:
      return { ...state, configModified: payload };
    case CLEAR_CONFIGS:
      return { ...state, configs: null, configsLoading: true };
    case GET_PROJECTLIST:
      return { ...state, projectsList: payload, projectListLoading: false };
    case GET_PROJECT:
      return { ...state, project: payload, projectLoading: false };
    case SET_PROJECT:
      return { ...state, project: payload,projectLoading: false };
    case CLEAR_PROJECT:
      return { ...state, project: null, projectLoading: true };
    case GET_DEPLOYMENTLIST:
      return {
        ...state,
        deploymentsList: payload,
        deploymentListLoading: false,
      };
    case GET_DEPLOYMENT:
      return { ...state, deployment: payload, deploymentLoading: false };
    case GET_DEVICELIST:
      return { ...state, devicesList: payload, deviceListLoading: false };
    case GET_DEVICE:
      return { ...state, device: payload, deviceLoading: false };
    case SET_DEVICE:
      return { ...state, device: payload, deviceLoading: false };
    case CLEAR_DEVICE:
      return { ...state, device: null, deviceLoading: true };
    case CLEAR_ADMIN:
      return {
        usersList: [],
        user: null,
        userListLoading: true,
        userLoading: true,
        clientsList: [],
        client: null,
        clientListLoading: true,
        clientLoading: true,
        buildingsList: [],
        building: null,
        buildingListLoading: true,
        buildingLoading: true,
        floorsList: [],
        floor: null,
        floorListLoading: true,
        floorLoading: true,
        roomsList: [],
        room: null,
        roomListLoading: true,
        roomLoading: true,
        projectsList: [],
        project: null,
        projectListLoading: true,
        projectLoading: true,
        deploymentsList: [],
        deployment: null,
        deploymentListLoading: true,
        deploymentLoading: true,
        devicesList: [],
        device: null,
        deviceListLoading: true,
        deviceLoading: true,
      };
    default:
      return state;
  }
}
